import { isNil } from 'lodash';
import { theme, fillObjectValues, type Types } from '@fiverr-private/theme';
import type { BreakpointValue, CarouselProps } from '../Carousel/types';
import type { TrackProps } from '../Track/types';
import { RequiredResponsiveSpacingType } from './types';

export const getBreakpointCalc = (breakpointValue: BreakpointValue, slidesGap: string): Types.CssCalc =>
    // 100% / the amount of visible slides - the total gap between the visible slides
    `calc(100% / ${breakpointValue} - (${slidesGap} * (${breakpointValue} - 1) / ${breakpointValue}))`;

const getSpacingValues = (
    source: Types.ResponsiveSpacingType,
    target: typeof theme.numericSpacing
): RequiredResponsiveSpacingType =>
    Object.keys(source).reduce((acc, key) => {
        acc[key] = target[source[key]];
        return acc;
    }, {} as RequiredResponsiveSpacingType);

export const getMinWidth = (
    breakpoints: CarouselProps['breakpoints'],
    slidesGap: TrackProps['slidesGap']
): Types.ResponsiveObject<Types.CssCalc> => {
    const defaultSlidesGap = typeof slidesGap === 'object' ? slidesGap : { default: slidesGap };
    const filledSlidesGapObject = fillObjectValues(breakpoints, 4, defaultSlidesGap);
    const spacingValues = getSpacingValues(filledSlidesGapObject, theme.numericSpacing);

    return Object.keys(breakpoints).reduce((acc, key) => {
        if (!isNil(breakpoints[key])) {
            acc[key] = getBreakpointCalc(breakpoints[key], `${spacingValues[key]}px`);
        }
        return acc;
    }, {});
};
